import React from "react";
import useAnimation from "../../../hooks/useAnimation";
import Animation from "../../../../static/animations/zipstocks/here-to-help-animation.json";

const HereToHelp = ({ content }) => {
  useAnimation({
    container: "#here-to-help__animation",
    animationData: Animation,
    assetsPath: "/animations/zipstocks/assets/here-to-help/",
  });

  return (
    <div className="container">
      <div className="zipstocks here-to-help">
        <div className="row flex-column-reverse flex-lg-row">
          <div
            id="here-to-help__animation"
            className="col-12 col-lg-6"
            data-sal="slide-up"
          ></div>
          <div className="col-12 col-lg-6 mb-4 mb-lg-0 align-self-center">
            <p className="label">Customer Support</p>
            <h2 className="mb-4">{content.nodes[0].acfPartials.pHeading}</h2>
            <div
              className="mb-5"
              dangerouslySetInnerHTML={{
                __html: content.nodes[0].acfPartials.pContent,
              }}
            />
            <a
              className="faq-bottom-link"
              href={content.nodes[0].acfPartials.pButtonUrl}
              rel="noreferrer noopener"
            >
              {content.nodes[0].acfPartials.pButtonText}{" "}
              <i className="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HereToHelp;
